import { getFramework } from '@/framework';
import { base64Kit } from '@/utils/base64-kit';
import { createCanvas, loadImageAsync } from '@/utils/file-kit';
import type { IBackgroundLayerProps, ILayerProps, ISize } from '@/version-types';
import { renderBackgroundLayerCanvas } from './render-to-canvas';

/**
 * 导出用于绘制到舞台的背景图层结果
 */
export const renderLayerToStage = async (
    layer: ILayerProps,
    stageSize: ISize,
    identity: string,
): Promise<HTMLCanvasElement | undefined> => {
    const { width: stageWidth, height: stageHeight } = stageSize;
    const data = layer.data as IBackgroundLayerProps;
    const { url } = data;

    let baseImage: HTMLCanvasElement | HTMLImageElement | undefined;
    if (url) {
        await base64Kit.getRemoteUrlAsync(url);
        try {
            baseImage = await loadImageAsync(url);
        } catch (_) {
            const framework = getFramework(identity);
            baseImage = createCanvas(1, 1).canvas;
            framework.service.reportImageError({ layerId: layer.id, imageUrl: url });
        }
    }

    return renderBackgroundLayerCanvas({
        layer,
        stageWidth,
        stageHeight,
        baseImage,
        validateImageSize: true,
    });
};
